export default __webpack_public_path__ + "static/hero_tablet-02223c1469ce5e370c6cb3c656c3e82f.webp";